import { render } from "./CheckoutWhatYouGet.vue?vue&type=template&id=ee0f4014"
import script from "./CheckoutWhatYouGet.vue?vue&type=script&lang=js"
export * from "./CheckoutWhatYouGet.vue?vue&type=script&lang=js"

import "./CheckoutWhatYouGet.vue?vue&type=style&index=0&id=ee0f4014&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__